module.exports = __webpack_public_path__ + "static/media/page3image3-mobile.7b81df11.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/components/MessageIntro/page3image3-mobile.png
// module id = 620
// module chunks = 0